import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { useContext } from 'react';
import { createUseStyles, useTheme } from 'react-jss';
import GeneralError from '../../components/GeneralError';
import LoadingState from '../../components/LoadingState';
import ManageAppointmentDetails from '../../components/ManageAppointmentDetails';
import { AppointmentContext } from '../../contexts/AppointmentContext';

const useStyles = createUseStyles((theme) => ({
  root: {
    background: theme.palette.neutral[200],
    margin: '2rem 0.5rem',
  },
  transparent: {
    background: 'transparent',
  },
}));

const ManageAppointment = ({ confirmation, loading }) => {
  const classes = useStyles({ theme: useTheme() });

  const [appointment] = useContext(AppointmentContext);

  if (loading) {
    return <LoadingState />;
  }

  if (!appointment.id && appointment.reloading) {
    return null;
  }

  if (!appointment.id) {
    return <GeneralError />;
  }

  // [COCO-9395] A script tracks this section element by it's id
  // Changes to this component may break broadcast-view-dimensions.blade.php
  return (
    <section
      className={classNames(classes.root, classes.transparent)}
      data-testid="manage-mobile"
      id="broadcast-container-manage-mobile"
    >
      <ManageAppointmentDetails confirmation={confirmation} />
    </section>
  );
};

ManageAppointment.propTypes = {
  confirmation: PropTypes.bool.isRequired,
  loading: PropTypes.bool.isRequired,
};

export default ManageAppointment;
